import { J as JuiIcon$1, d as defineCustomElement$1 } from './jui-icon2.js';

const JuiIcon = JuiIcon$1;
const defineCustomElement = defineCustomElement$1;

export { JuiIcon, defineCustomElement };

//# sourceMappingURL=jui-icon.js.map